export const FINANCIAL_LIST_REQUEST = "FINANCIAL_LIST_REQUEST"
export const FINANCIAL_LIST_SUCCESS = "FINANCIAL_LIST_SUCCESS"
export const FINANCIAL_LIST_FAIL = "FINANCIAL_LIST_FAIL"

